import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import React from 'react';
import { useRef } from 'react';
import { CarouselSettings } from '~/components/common/Carousel/types';
import { useScreenSize } from '~/context/common/DeviceContext';

export default function useHomeCarouselSettings(
  customSettings: Partial<CarouselSettings> = {}
): {
  carouselRef: React.RefObject<HTMLElement>;
  values: CarouselSettings;
} {
  const { width: screenWidth } = useScreenSize();
  const carouselRef = useRef<HTMLElement>(null);
  const horizontalPageMargin = 48;

  const calculateWidth = () => {
    const defaultWidth = 288;
    const widthGap = customSettings.widthGap || defaultWidth;
    const workingWidth =
      carouselRef?.current?.offsetWidth || screenWidth - horizontalPageMargin;

    return workingWidth / widthGap;
  };

  const shouldUseDefaultDesktopSettings =
    (customSettings.useDesktopDefaultSettings ?? true) &&
    screenWidth >= legacyBreakpoints.xl;

  const defaultSettings: CarouselSettings = {
    arrows: false,
    centerMode: false,
    className: '',
    dots: false,
    heading: '',
    eventBaseName: 'Sem Carousel',
    infinite: false,
    isSkeleton: false,
    slidesToShow: shouldUseDefaultDesktopSettings ? 4 : calculateWidth(),
    slidesToScroll: shouldUseDefaultDesktopSettings
      ? 4
      : Math.floor(calculateWidth())
  };

  const values: CarouselSettings = { ...defaultSettings, ...customSettings };

  return { carouselRef, values };
}
